export default class StickyMenu {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $(document).ready(function() {
            const nav = $('.sticky-menu');
            const nav_height = nav.outerHeight();
            const nav_offset = nav.offset()?.top - 5;

            $('.sticky-menu__burger').on('click', function(e) {
                e.preventDefault();
                $(this).toggleClass('active');
                $('.sticky-menu__right').toggleClass('active');
            });

            $('.sticky-menu__link').on('click', function(e) {
                e.preventDefault();
                $('.sticky-menu__right, .sticky-menu__burger').removeClass('active');
                const id = $(this).attr('href');
                const top = $(id).offset().top;
                $('body,html').animate({ scrollTop: top - (nav_height - 10) }, 500);
            });

            const sections = $('.wp-block-group[id]');

            $(window).on('scroll', function() {
                const cur_pos = $(this).scrollTop();

                if (cur_pos >= nav_offset - 100) {
                    nav.addClass('sticky');
                } else {
                    nav.removeClass('sticky');
                }

                sections.each(function() {
                    const top = $(this).offset().top - nav_height;
                    const bottom = top + $(this).outerHeight();

                    if (cur_pos >= top && cur_pos <= bottom) {
                        nav.find('a').removeClass('active');
                        sections.removeClass('active');

                        $(this).addClass('active');
                        nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
                    }
                });
            });
        });
    }
}
